import type { IconSvgObject } from './types';

const Xml02Icon: IconSvgObject = [
  ["path", { d: "M12.5 19V14L14.5 16.5L16.5 14V19M19 14V19H21M7 14L8.5 16.5M8.5 16.5L10 19M8.5 16.5L10 14M8.5 16.5L7 19", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M19 22H5C3.89543 22 3 21.1046 3 20L3 4C3 2.89543 3.89543 2 5 2H12L19 9V11M18.5 9H13.998C12.8935 9 11.998 8.10457 11.998 7V2.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default Xml02Icon;
